"use client"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"
import ImageContainer from "../../../reusable/wrappers/ImageContainer"
import WarrantyBody from "./WarrantyBody"
import WarrantyHeader from "./WarrantyHeader"

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
`

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  max-width: 1400px;
  padding-right: 150px;
  padding-left: 150px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 20px;
  }
`

const WarrantyPage = () => {
  const isDesktop = useIsDesktop()
  return (
    <StyledPageWrapper $padding={"0"}>
      <StyledPageDiv>
        <ImageContainer
          src={isDesktop ? "/img/Warranty.jpg" : "/img/Warrantymobile.jpg"}
        />
        <BreadCrumbsWrapper name="Warranty" />
        <StyledTextWrapp>
          <WarrantyHeader />
          <WarrantyBody />
        </StyledTextWrapp>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default WarrantyPage
